import {SListTabs} from "shj-components";
import ChannelClass from "@/pages/channelConfig/channelClass";
import ChannelLibrary from "@/pages/channelConfig/channelLibrary";

const ChannelConfig = () => {

  const items = [
      {
        key: 'channelClass',
        label: '渠道分类',
        children: <ChannelClass/>
      },
    {
        key: 'channelLibrary',
        label: '渠道库',
        children: <ChannelLibrary/>
      },
  ]

  return <SListTabs items={items} hideExtra={true} auth={true} />
}

export default ChannelConfig